export class ContatoCadastro {
  nome?: string;
  numero?: string;
  email?: string;

  constructor(nome: string, numero: string, email: string) {
    this.nome = nome;
    this.numero = numero;
    this.email = email;
  }
}
